const availableLocales = [{ value: 'fi', text: 'Suomeksi' }];

const defaultLocale = availableLocales[0];

module.exports = {
  defaultLocale,
  availableLocales,
};
